import { TableField } from "../../table-field";

export const fieldsPermissoes: TableField[] = [
    { key: 'Id', label: 'Id', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: 'Caminho', label: 'Caminho', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: 'Rota', label: 'Rota', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: 'Perfil', label: 'Perfil', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: 'ApenasUg', label: 'Apenas UG', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: "actions", label: "Ações", tdClass: ["align-middle", "col-actions"], thClass: "text-center", sortable: false }
]